const runtimeConfigRaw = window.__RUNTIME_CONFIG__;

export const runtimeConfig = {
  ...runtimeConfigRaw,
  IS_PRODUCTION: runtimeConfigRaw.EVERNOW_ENV === "prod",
};
